'use client';

import Container from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { CustomText, TextHeadlineSmall } from '@/components/text/Texts';
import routes from '@/constants/routes';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { MdCheckCircle } from 'react-icons/md';

type Props = {
	showSuccessScreen: boolean;
	setShowSuccessScreen: (value: boolean) => void;
};

export default function CreatePasswordSuccess({
	setShowSuccessScreen,
	showSuccessScreen = false,
}: Props) {
	const navigate = useNavigate();
	return (
		<Container className="custom-dialog-container font-poppins">
			<div className="flex justify-center">
				<MdCheckCircle size={24} className="text-success mb-4" />
			</div>
			<TextHeadlineSmall
				text="Password changed successfully!"
				className="text-onSurface"
			/>
			<Spacing height="h-4" />
			<CustomText
				className="text-onSurfaceVariant text-base"
				text="You will now redirected to the login page"
			/>
			<Container className="mt-8 mb-2 flex gap-8 justify-end pr-2">
				<Link
					to=""
					className="text-label-large text-primary font-medium"
					onClick={(e) => {
						e.preventDefault();
						setShowSuccessScreen(!showSuccessScreen);
						navigate(routes['/login']);
					}}
				>
					Got It
				</Link>
			</Container>
		</Container>
	);
}
